import { CognitoUserPool } from "amazon-cognito-identity-js"

const poolData = {
    UserPoolId: import.meta.env.VITE_APP_USERPOOL_ID,
    ClientId: import.meta.env.VITE_APP_USERPOOL_CLIENT_ID
}

export default new CognitoUserPool(poolData)